import { RecoilRoot, useRecoilValue } from "recoil";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { authState } from "recoil/auth";
import { BrowserRouter, Route, Routes, Navigate, Link } from "react-router-dom";
import Modal from "react-modal";
import ApplyRouter from "./components/pages/ApplyRouter";
import ReceiptRouter from "./components/pages/ReceiptRouter";
import RaterLogin from "./components/pages/rater/RaterLogin";
import AdminLogin from "./components/pages/admin/AdminLogin";
import Evaluation from "./components/pages/rater/Evaluation";
import RaterExamRoom from "./components/pages/rater/RaterExamRoom";
import AdminRouter from "./components/pages/admin/AdminRouter";
import AdminPreset from "./components/pages/admin/AdminPreset";
import AdminAccount from "./components/pages/admin/AdminAccount";
import AdminSetting from "./components/pages/admin/AdminSetting";
import AdminSettingReceipt from "./components/pages/admin/AdminSettingReceipt";
import RaterStyleProvider from "./components/pages/style/RaterStyleProvider";
import AdminStyleProvider from "./components/pages/style/AdminStyleProvider";
import ErrorPageGroupId from "./components/pages/ErrorPageGroupId";
import CommonStyleProvider from "./components/pages/style/CommonStyleProvider";
import AdminQuestion from "./components/pages/admin/AdminQuestion";
import ExamResult from "./components/pages/admin/examRoom/ExamResult";
import LanguageSelect from "./components/pages/LanguageSelect";
import RaterExamRoomQuestion from "./components/pages/rater/RaterExamRoomQuestion";

Modal.setAppElement("#root");

function App() {
  const queryClient = new QueryClient();
  const auth = useRecoilValue(authState);

  return (
    <BrowserRouter>
      {/* todo 백엔드 api로 계정 유형 받아오면 css 분기 구현 */}

      <QueryClientProvider client={queryClient}>
        <Routes>
          <Route path="" element={<CommonStyleProvider />}>
            <Route path="apply/:uuid" element={<ApplyRouter />} />
            {/* <Route path="receipt/:uuid" element={<ReceiptRouter />} /> */}
            <Route path="/" element={<ReceiptRouter />} />
          </Route>
          <Route path="admin" element={<AdminStyleProvider />}>
            {auth?.token && auth?.user?.type === 0 ? (
              <>
                <Route
                  path="login"
                  element={<Navigate to="/admin/home" replace />}
                />
                <Route path="/admin/home" element={<AdminRouter />} />
                <Route path="/admin/question" element={<AdminQuestion />} />
                <Route path="/admin/preset" element={<AdminPreset />} />
                <Route path="/admin/account" element={<AdminAccount />} />
                <Route
                  path="/admin/result/:tester_sn"
                  element={<ExamResult />}
                />
              </>
            ) : (
              <>
                <Route path="login" element={<AdminLogin />} />
                <Route path="" element={<Navigate to="login" replace />} />
                <Route path="*" element={<Navigate to="login" replace />} />
              </>
            )}
          </Route>
          <Route path="rater" element={<RaterStyleProvider />}>
            {auth?.token && auth?.user?.type === 1 ? (
              <>
                <Route
                  path="login"
                  element={<Navigate to="/rater/examroom" replace />}
                />
                <Route path="examroom" element={<RaterExamRoom />} />
                <Route path="examroom/:room_sn" element={<Evaluation />} />
                <Route
                  path="examroom/question/:room_sn"
                  element={<RaterExamRoomQuestion />}
                />
              </>
            ) : (
              <>
                <Route path="login" element={<RaterLogin />} />
                <Route path="" element={<Navigate to="login" />} replace />
                <Route path="*" element={<Navigate to="login" />} replace />
              </>
            )}
          </Route>
          <Route path="*" element={<ErrorPageGroupId />} />
        </Routes>
      </QueryClientProvider>
    </BrowserRouter>
  );
}

export default App;
